/* eslint-disable react/no-array-index-key */
import React from "react";
import PropTypes from "prop-types";
import {
  Grid,
  IconButton,
  Button,
  Paper,
  Typography,
  Divider,
  TextField,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import useSharedStyles from "./SharedStyle";

const DividendInformation = ({
  dividendEntries,
  handleDividendChange,
  handleAddDividend,
  handleRemoveDividend,
  disabled,
  // eslint-disable-next-line no-unused-vars
  styles
}) => {
  const classes = useSharedStyles();

  const calculateTotal = () =>
    dividendEntries
      .reduce((sum, entry) => {
        const amount = parseFloat(entry.amount) || 0;
        return sum + amount;
      }, 0)
      .toFixed(2);
    
  return (
    <Paper className={classes.paper} style={styles?.paper}>
      <Typography variant="h6" className={classes.sectionTitle} style={styles?.header}>
        Dividend Information
      </Typography>

      {dividendEntries.length > 0 && (
        <>
          {dividendEntries.map((entry, index) => (
            <div key={index} className={classes.dividendEntry}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                  <div className={classes.inputWrapper}>
                    <Typography className={classes.label}>
                      Financial Year
                      <span className={classes.requiredAsterisk}>*</span>
                    </Typography>
                    <TextField
                      variant="outlined"
                      type="text"
                      size="small"
                      required
                      className={classes.inputField}
                      value={entry.financialYear}
                      placeholder="YYYY-YYYY"
                      onChange={(e) =>
                        handleDividendChange(
                          index,
                          "financialYear",
                          e.target.value
                        )
                      }
                      fullWidth
                      autoComplete="off"
                      disabled={disabled}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={3}>
                  <div className={classes.inputWrapper}>
                    <Typography className={classes.label}>
                      Payment Date
                      <span className={classes.requiredAsterisk}>*</span>
                    </Typography>
                    <TextField
                      variant="outlined"
                      size="small"
                      className={classes.inputField}
                      type="date"
                      required
                      value={entry.paymentDate}
                      onChange={(e) =>
                        handleDividendChange(
                          index,
                          "paymentDate",
                          e.target.value
                        )
                      }
                      fullWidth
                      inputProps={{
                        max: entry.maxPaymentDate || "",
                      }}
                      autoComplete="off"
                      disabled={disabled}

                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={3}>
                  <div className={classes.inputWrapper}>
                    <Typography className={classes.label}>
                      Warrant No
                      <span className={classes.requiredAsterisk}>*</span>
                    </Typography>
                    <TextField
                      variant="outlined"
                      type="text"
                      size="small"
                      required
                      className={classes.inputField}
                      value={entry.warrantNo}
                      placeholder="00000"
                      onChange={(e) =>
                        handleDividendChange(index, "warrantNo", e.target.value)
                      }
                      fullWidth
                      autoComplete="off"
                      disabled={disabled}

                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={2}>
                  <div className={classes.inputWrapper}>
                    <Typography className={classes.label}>
                      Dividend Amount
                      <span className={classes.requiredAsterisk}>*</span>
                    </Typography>
                    <TextField
                      variant="outlined"
                      size="small"
                      className={classes.inputField}
                      type="text"
                      required
                      value={entry.amount}
                      placeholder="0.00"
                      inputProps={{ step: "0.01", min: "0" }}
                      onChange={(e) =>
                        handleDividendChange(index, "amount", e.target.value)
                      }
                      fullWidth
                      autoComplete="off"
                      disabled={disabled}

                    />
                  </div>
                </Grid>
                { handleRemoveDividend && <Grid item xs={12} md={1}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-end",
                      height: "100%",
                    }}
                  >
                    <IconButton
                      onClick={() => handleRemoveDividend(index)}
                      disabled={dividendEntries.length === 1 && index === 0}
                      color="secondary"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </div>
                </Grid>}
              </Grid>
            </div>
          ))}
        </>
      )}

     { handleAddDividend &&  <Button
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        onClick={handleAddDividend}
        className={classes.addButton}
        disabled={disabled}
      >
        Add Another Dividend Entry
      </Button>}

      <Divider />

      <div className={classes.totalSection}>
        <Typography variant="subtitle1" className={classes.totalLabel}>
          <strong>Total</strong>
        </Typography>
        <Typography variant="subtitle1" className={classes.totalAmount}>
          {calculateTotal()}
        </Typography>
      </div>
    </Paper>
  );
};

DividendInformation.propTypes = {
  dividendEntries: PropTypes.array.isRequired,
  handleDividendChange: PropTypes.func,
  handleAddDividend: PropTypes.func,
  handleRemoveDividend: PropTypes.func,
  disabled: PropTypes.bool,
  styles:PropTypes.object
};

export default DividendInformation;
